import img1 from "./1.jpeg";

export default [
  img1,
];
